/**
 * Утилита для форматирования баллов с поддержкой дробных чисел
 * Отображает дробные числа с точностью до 2 знаков после запятой,
 * целые числа отображаются без десятичной части
 * @param {number} value - Значение для форматирования
 * @returns {string} - Отформатированная строка
 */
export const formatPoints = (value) => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '0';
  }

  // Если число целое, отображаем без десятичной части
  if (Number.isInteger(value)) {
    return String(value);
  }

  // Для дробных чисел показываем до 2 знаков после запятой
  // Убираем лишние нули в конце
  const formatted = value.toFixed(2);
  // Убираем завершающие нули после точки, но оставляем точку если есть хотя бы одна значащая цифра
  return formatted.replace(/\.?0+$/, '') || '0';
};
